import React from 'react'

function Home() {
  return (
    <p>Welcome to Admin Dashboard</p>
  )
}

export default Home